import Vue from "vue";
import Router from "vue-router";

function lazyLoad(view) {
    return () => import(`@/views/${view}`);
}

Vue.use(Router);

let router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "Index",
            component: lazyLoad("Main")
        },
        {
            path: "/ForgottenPassword",
            name: "ForgottenPassword",
            component: lazyLoad("ForgottenPassword")
        },
        {
            path: "/RegisterForPassportNumber",
            name: "RegisterForPassportNumber",
            component: lazyLoad("RegisterForPassportNumber")
        },
        {
            path: "/RegisterForInstaller",
            name: "RegisterForInstaller",
            component: lazyLoad("RegisterForInstaller")
        },
        {
            path: "/ActivateAccount/:token?",
            name: "ActivateAccount",
            component: lazyLoad("ActivateAccount")
        },
        {
            path: "/ResetPassword/:token?",
            name: "SetPassword",
            component: lazyLoad("SetPassword")
        }
    ]
});

export default router;